import { useSelector } from "react-redux";

export const useCurrentTypeHook = () => {
  const currency = useSelector((state) => state.organisation.organisation.preferences?.currency);
  return currency;
};